export const EHRInstallationType_Epic = 'epic';
export const EHRInstallationType_Cerner = 'cerner';
export const EHRInstallationType_Deploy = 'deploy';
export const EHRInstallationTypes = [EHRInstallationType_Cerner, EHRInstallationType_Epic, EHRInstallationType_Deploy];
//# sourceMappingURL=types.js.map